import {useForm} from 'react-hook-form';
import {useId} from 'react';
import {User} from '@ui/types/user';
import {AccountSettingsPanel} from '../account-settings-panel';
import {Button} from '@ui/buttons/button';
import {Form} from '@ui/forms/form';
import {FormTextField} from '@ui/forms/input-field/text-field/text-field';
import {useUpdateContactInfo} from './update-contact-info';
import {Trans} from '@ui/i18n/trans';
import {AccountSettingsId} from '@common/auth/ui/account-settings/account-settings-sidenav';
import {GoogleMapsAddressInput} from './google-maps-address-input';

interface Props {
  user: User;
}

interface ContactInfoFormData {
  phone?: string;
  cpf?: string;
  address_json?: string;
}

export function ContactInfoPanel({user}: Props) {
  const formId = useId();
  const form = useForm<ContactInfoFormData>({
    defaultValues: {
      phone: user.phone || '',
      cpf: user.cpf || '',
      address_json: user.address_json || '',
    },
  });
  const updateContactInfo = useUpdateContactInfo(form);

  return (
    <AccountSettingsPanel
      id={AccountSettingsId.ContactInfo}
      title={<Trans message="Personal Data" />}
      actions={
        <Button
          type="submit"
          variant="flat"
          color="primary"
          form={formId}
          disabled={updateContactInfo.isPending || !form.formState.isValid}
        >
          <Trans message="Save" />
        </Button>
      }
    >
      <Form
        form={form}
        className="flex flex-col gap-24"
        onSubmit={newDetails => {
          updateContactInfo.mutate(newDetails);
        }}
        id={formId}
      >
        <GoogleMapsAddressInput
          name="address_json"
          label={<Trans message="Address" />}
          description={<Trans message="Start typing your address for autocomplete suggestions" />}
        />
        <FormTextField
          name="cpf"
          label={<Trans message="CPF" />}
          placeholder="000.000.000-00"
          description={<Trans message="Brazilian taxpayer ID number" />}
        />
        <FormTextField
          name="phone"
          label={<Trans message="Phone" />}
          placeholder="+55 (11) 99999-9999"
          description={<Trans message="Your contact phone number" />}
        />
      </Form>
    </AccountSettingsPanel>
  );
}
